import { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSWRConfig } from 'swr';
import container from 'src/container';
import { supportModeService } from 'src/services/supportMode.service';
import { UserActions } from 'src/state/_actions';
import { useNotification } from 'src/components/Notification/useNotfication';

export const useEnterSupportMode = () => {
    const [isEnteringSupport, setIsEnteringSupport] = useState(false);
    const pending = useRef(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const notify = useNotification();
    const { mutate } = useSWRConfig();
    const enterSupport = async (organizationId: string, path = '/app/home') => {
        if (pending.current) return;
        pending.current = true;
        setIsEnteringSupport(true);
        try {
            const { munduClient } = container.cradle;
            const session = await munduClient.createSupportSession(
                organizationId,
            );
            supportModeService.set(session);
            const user = await munduClient.getUser();
            await mutate(() => true, undefined, { revalidate: false });
            dispatch(UserActions.setUser(user));
            history.push(path);
        } catch (error) {
            supportModeService.clear();
            if (error instanceof Error) notify(error.message, true);
        } finally {
            pending.current = false;
            setIsEnteringSupport(false);
        }
    };
    return { enterSupport, isEnteringSupport };
};
